// helpers
import setEnv from "@global/helpers/setEnv";
import ignoreByDom from "@global/helpers/ignoreByDom";
import excuteByDom from "@global/helpers/excuteByDom";

// globalUI
import { initButton as gotop } from "@global/components/global/gotop";
import accordion from "@global/components/global/accordion";
import hashAccordion from "@global/components/global/hashAccordion";
import floatLabel from "@global/components/global/floatLabel";
import focusInput from "@global/components/global/focusInput";
import formInputOrder from "@global/components/global/formInputOrder";
import Popup from "@global/components/global/popup";

// import triggerSelect from 'components/global/triggerSelect'
import slideNotice from "@page/common/js/template/slideNotice";
import newsletterAndBookmark from "@page/common/js/template/newsletterAndBookmark";
import triggerSelect from "@page/common/js/template/triggerSelect";

//import Lightbox from '@global/components/global/Lightbox'

// promotion
import FooterNotice from "@global/components/promotion/footerNotice";
import navigation from "@page/common/js/template/navigation_mq";

// expose functions to Global namespace
window.mq = window.mq || {};
window.nowEnv = window.nowEnv || {};
window.nowBrand = window.mq;

mq.constants = {
	absCanvasUrl: "/Home/HomeNewArrival/",
	productDetailUrl: "/Product/DetailJsonData/",
	productActivity: "/product/SearchActivity/",
	addToCartUrl: "/Shopping/MiniCart/",
	addToCartUrl_Pre: "/Shopping/PreOrderMiniCart/",
	addToWishList: "/Member/AddWishList/",
	initWishList: "/Member/InitWishList/",
	loginMode: "/Member/IsLogin",
	GetBanners: "/Home/GetBanners",
};

mq.miniCartConfig = {
	cartCookieName: "MiniCart",
	preCartCookieName: "PreOrderMiniCart",
};

mq.globalConfig = {
	id: "meierq",
	name: "meier.q",
	topBannerOffset: true,
	notAllHttps: true,
	devPort: "83",
	host: "www.meierq.com",
};

// 每個區塊的預設圖片路徑
mq.imagePlaceholder = {
	default: "/img/inf_640x803.gif",
};

mq.initRendered = true;

function globalCtrl() {
	// environment
	nowEnv.NowIsDev = setEnv.isDev(); // 得知是否為本機開發環境
	nowEnv.NowIsTest = setEnv.isTest(); // 得知是否為測試環境
	nowEnv.NowMyEquipment = setEnv.myEquipment(); // 得知現在的裝置類型
	nowEnv.NowIsLogin = setEnv.isLogin(); // 得知是否登入
	nowEnv.NowMyCookie = setEnv.myCookie(); // 得知目前裝置是否允許Cookie
	nowEnv.NowMyStorage = setEnv.myStorage(); // 得知目前裝置是否允許Storage
	setEnv.windowReload();

	// scripts ignore
	// ignoreByDom(
	//   setEnv.windowReload,
	//   ['#KrispyKreme']
	// )

	// require component

	// const navigation = require('./template/navigation_mq')

	navigation.navGlobal();
	// daisy miniCart.init()

	// globalUI
	triggerSelect();
	gotop(".ui-gotop", {
		toggle: { target: 200 },
		duration: 1500,
	});
	accordion(".order-accordion", {
		collapse: true,
		children: "div",
	});
	formInputOrder({
		inputArray: ["#account, #username", "#password", "#captchaTxt, #LoginCode"],
		submitButton: "#btnLogin, #btnShoppingLogin",
	});

	// condition
	const NowMyEquipment = nowEnv.NowMyEquipment;

	if (NowMyEquipment) {
		// 手機版
		// template
		navigation.navMobile();
		// globalNotice.globalNoticeMobile()

		// promotion
		excuteByDom(() => {
			const footerNotice = new FooterNotice();
			footerNotice.init();
		}, ["#home-content"]);
	} else {
		// 我是電腦版
		// template
		// miniCart.render()
		navigation.navDesktop();

		// globalUI
		// htmlNoTouch()

		// promotion
		// topBanner(() => { $('#topBanner').slideDown() })
		// globalNotice.globalNotice()
	}

	// expose functions to Global namespace
	mq.Notice = slideNotice;
	mq.popupType = "englishBtn";
	mq.alert = Popup("alert");
	mq.confirm = Popup("confirm");
	mq.notice = Popup("notice");
}

export default globalCtrl;
